module.exports = __webpack_public_path__ + "media/images/kds/refund-383036436b5a35f115d3b235cbd3f294.jpeg";